export const CHANGE_LANGUAGE = "CHANGE_LANGUAGE"
export const RESET = "RESET"
export const RESET_PATH = "RESET_PATH"
export const RESET_USER = "RESET_USER"
export const TOGGLE_LOADING = "TOGGLE_LOADING"
export const UPDATE_PATH = "UPDATE_PATH"
export const UPDATE_USER = "UPDATE_USER"